// Google Analytics
(function( $ ){
    window.dataLayer = window.dataLayer || [];

    function gtag(){
        dataLayer.push( arguments );
    }

    var config = {};

    gtag( 'js', new Date() );
    gtag( 'config', process.env.MIX_GOOGLE_ANALYTICS, config );
})( jQuery );

// Google Optimize
(function( i, s, o, g, r, a, m ){
    i[ 'GoogleAnalyticsObject' ] = r;
    i[ r ] = i[ r ] || function(){
        (i[ r ].q = i[ r ].q || []).push( arguments )
    }, i[ r ].l = 1 * new Date();

    a = s.createElement( o ), m = s.getElementsByTagName( o )[ 0 ];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore( a, m )
})( window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga' );

ga( 'create', process.env.MIX_GOOGLE_ANALYTICS, 'auto' );
ga( 'require', 'GTM-K7C5KJS' );
ga( 'send', 'pageview' );